import { Colors } from '@factorialco/deprecated-design-system'

import { CardWithStatus } from './types'

export const statusColor = (card: CardWithStatus): Colors => {
  switch (card.approval?.status) {
    case 'rejected':
      return 'grey600'
    case undefined:
      break
    default:
      return 'viridian800'
  }

  switch (card.status) {
    case 'pending':
    case 'active':
    case 'inactive':
      return 'viridian800'
    case 'requested':
      return 'viridian1000'
    case 'rejected':
    case 'canceled':
      return 'grey600'
    default:
      return 'viridian800'
  }
}
